import { Link } from 'gatsby'
import React from 'react'

import ArrowIcon from '../../../../../assets/ArrowIcon'
import Button from '../../../../ui/Button'
import './navigation.scss'

export interface NavbarCategorieViewProps {
  isLink?: boolean
  closeModal?: () => unknown
  setSubcategoriPosition: (position: number) => void
  setViewNumber: (position: number) => void
  setBreadcrumb: (title: string) => void
  slug?: string
  mainSlug?: string
  indicators: string[]
  setIndicators: (indicators: string[]) => void
  subCategorieItems: {
    title: string
    slug: string
    subcategorie: {
      title: string
      slug: string
    }[]
  }[]
  viewNumber: number
  setCurrentItem: (currentItem: string) => void
  currentItem: string
}

const NavbarCategorieView = ({
  indicators,
  closeModal,
  setBreadcrumb,
  setSubcategoriPosition,
  setIndicators,
  setViewNumber,
  subCategorieItems,
  viewNumber,
  isLink = false,
  slug = '',
  mainSlug = '',
  setCurrentItem,
  currentItem,
}: NavbarCategorieViewProps) => {
  const navigation = (itemTitle: string, index: number) => {
    setViewNumber(viewNumber)
    setBreadcrumb(itemTitle)
    setSubcategoriPosition(index)
  }

  const lowCase = (string: string) => {
    return string.toLocaleLowerCase()
  }

  const closeMenu = () => {
    closeModal?.()
  }

  const isFoodRestriction = mainSlug === 'restricao-alimentar'

  return (
    <>
      <div className="navbar-breadcrumb">
        <Button
          className="text-back-button"
          onClick={() => {
            setViewNumber(0)
            setIndicators([])
            setCurrentItem('')
          }}
        >
          Inicio
        </Button>
        {indicators?.map((item: string, index: number) => (
          <div key={item}>
            <ArrowIcon rotate="Left" />
            <Button
              className={
                index + 2 === viewNumber ? 'select-button' : 'no-select-button'
              }
              onClick={() => {
                setViewNumber(index + 1)
                setIndicators(
                  indicators.filter(
                    (_: string, qty: number) => qty < indicators.length - 1
                  )
                )
              }}
            >
              <div className="text-button-style">
                <p>{item}</p>
              </div>
            </Button>
          </div>
        ))}
      </div>

      <div className="navbar-back-button">
        <ArrowIcon rotate="Right" />

        <Button
          style={{ padding: '4px' }}
          onClick={() => {
            setViewNumber(viewNumber - 2)
            setCurrentItem('')
            setIndicators(
              indicators.filter(
                (_: string, index: number) => index < indicators.length - 1
              )
            )
          }}
        >
          <p>Voltar</p>
        </Button>
      </div>
      <div
        className={`${
          isFoodRestriction
            ? 'navbar-categorie-restriction-title'
            : 'navbar-categorie-title'
        }`}
      >
        <span>{indicators[indicators.length - 1]}</span>
        {!isFoodRestriction && (
          <Link
            onClick={() => closeMenu()}
            to={`/${lowCase(mainSlug)}/${lowCase(slug)}`}
          >
            Ver tudo
          </Link>
        )}
      </div>
      <div className="navbar-items-container">
        {subCategorieItems?.map(
          (
            item: {
              title: string
              slug: string
              subcategorie: {
                title: string
                slug: string
              }[]
            },
            index: number
          ) => {
            const linkFoodRestriction = isFoodRestriction
              ? `/${lowCase(mainSlug)}/${lowCase(item.slug)}`
              : `/${lowCase(mainSlug)}/${lowCase(slug)}/${lowCase(item.slug)}`

            return (
              <Link
                to={
                  isLink || !item.subcategorie || item.subcategorie.length === 0
                    ? linkFoodRestriction
                    : ''
                }
                onClick={() => {
                  setCurrentItem(item.title)
                  if (
                    isLink ||
                    !item.subcategorie ||
                    item.subcategorie.length === 0
                  ) {
                    closeMenu()

                    return
                  }

                  navigation(item.title, index)
                }}
                className={currentItem === item.title ? 'currentItem' : ''}
                key={item.title}
              >
                {item.title}
                {isLink === true ||
                  item.title === 'Sem Açúcar' ||
                  (item?.subcategorie?.length !== 0 && (
                    <ArrowIcon
                      color={
                        currentItem === item.title &&
                        'var(--color-assistant-main)'
                      }
                      rotate="Left"
                    />
                  ))}
              </Link>
            )
          }
        )}
      </div>
    </>
  )
}

export default NavbarCategorieView
